import React from "react";

export default function ScienceBehind() {
  return (
    <div>
      {/* 🔹 Banner Section */}
      <div
        style={{
          backgroundImage: "url('/images/AboutOrgavitaz/Science_Behind.jpg')",
          backgroundSize: "cover",
          backgroundPosition: "center",
          height: "70vh",
          position: "relative", // ✅ Needed for absolute positioning inside
          marginBottom: "3rem",
          color: "#fff",
        }}
      >
        {/* Banner Overlay */}
        <div
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
          }}
        ></div>

        {/* Title at bottom of banner */}
        <div
          style={{
            position: "absolute",
            bottom: "20px",
            left: "50%",
            transform: "translateX(-50%)",
            backgroundColor: "rgba(0,0,0,0.5)",
            padding: "1rem 2rem",
            borderRadius: "10px",
            textAlign: "center",
          }}
        >
          <h1 className="display-6 m-0">Science Behind</h1>
        </div>
      </div>

      {/* 🔹 Book-style Sections */}
      <div className="row align-items-center">
    <div className="col-md-6 p-3">
      <h2>Broad-spectrum plant-based Vitamins</h2>
      <p style={{ textAlign: "justify" }}>
        Most “natural” vitamin supplements are chemically stripped down to 
        a single vitamer, which are more closely related to synthetic vitamins than true plant-based vitamins.
         Orgavitaz offers broad spectrum plant-based vitamins. For instance,
          Provitamin A as Mixed Carotenoids, B12 as Total Cobalmin and Corrinoids, Vitamin E as Total mixed tocochromanols, etc...
      </p>
    </div>
    <div className="col-md-6 p-3">
      <img
        src="/images/AboutOrgavitaz/Science_Behind.jpg"
        alt="Our Mission"
        className="img-fluid rounded"
        style={{ width: "100%", height: "350px", objectFit: "cover" }}
      />
    </div>
  </div>

  {/* 🔹 Section 2 (Image Left, Text Right) */}
  <div className="row align-items-center flex-row-reverse mt-5">
    <div className="col-md-6 p-3">
      <h2>Orgavitaz offers Vitamin’s Microenvironment</h2>
      <p style={{ textAlign: "justify" }}>
        Orgavitaz naturally occurring vitamin complex exhibit a systemic
         relationship with Co-factors, Enzymes, transporters and other functional
          metabolites of the body. Microenvironment is a collection of related bio-transformative
           agents as plant metabolites facilitating critical bodily functions.  For instance,
            Moringa oleifera leaf juice offers flavonoids, tannins, saponins and other alkaloids 
            including some flavoproteins as microenvironment to its vitamins complex. Lichens metabolites 
            facilitates hydroxylation in liver and kidney apart from offering bioactive vitamin D3 directly. 
            Shiitake provides a great mix of dietary minerals, cobalamins and carotenoids provide a systemic
             food vitamin complex. Amla provides a perfect Vitamin c complex microenvironment with its other
         metabolites like Bioflavonoids, Rutin, Quercetin, tannins, etc.
           </p>
    </div>
    <div className="col-md-6 p-3">
      <img
        src="/images/AboutOrgavitaz/Clinical_Mission.jpg"
        alt="Global Integration"
        className="img-fluid rounded"
        style={{ width: "100%", height: "350px", objectFit: "cover" }}
      />
    </div>
  </div>
   <div className="row align-items-center">
    <div className="col-md-6 p-3">
      <h2>Plant-based Solvents</h2>
      <p style={{ textAlign: "justify" }}>
        Water Extraction of vitamins involves assistance of 
        plant-based solvents for hydrolysis of vitamins.
         Our proprietary plant-based alternatives for organic solvents are selectively used
          to standardise vitamins. For Instance, Amla and Lemon for acid hydrolysis, plant-based vinegar,
           plant-based enzymes to represent amylases and takadiastases, etc.
      </p>
    </div>
    <div className="col-md-6 p-3">
      <img
        src="/images/AboutOrgavitaz/Development_Story.jpg"
        alt="Our Mission"
        className="img-fluid rounded"
        style={{ width: "100%", height: "350px", objectFit: "cover" }}
      />
    </div>
  </div>
     
    </div>
  );
}
